import { render, staticRenderFns } from "./Magiun.vue?vue&type=template&id=3f354274&scoped=true&"
import script from "./Magiun.vue?vue&type=script&lang=js&"
export * from "./Magiun.vue?vue&type=script&lang=js&"
import style0 from "./Magiun.vue?vue&type=style&index=0&id=3f354274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f354274",
  null
  
)

export default component.exports